import React, { JSX } from 'react'

const LikeIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="35"
    height="30"
    viewBox="0 0 35 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0085 1.54639C5.1922 1.54639 1.2876 5.40701 1.2876 10.1691C1.2876 18.7918 11.5942 26.6306 17.1438 28.454C22.6935 26.6306 33.0001 18.7918 33.0001 10.1691C33.0001 5.40701 29.0955 1.54639 24.2792 1.54639C21.3299 1.54639 18.7215 2.99422 17.1438 5.21026C16.3397 4.07771 15.2714 3.15342 14.0293 2.51565C12.7873 1.87788 11.4081 1.54541 10.0085 1.54639Z"
      fill={props.fill ?? 'white'}
      stroke={props.stroke ?? '#4D4D4D'}
      strokeWidth="2.2125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default LikeIcon
